import Link from "next/link";

const LinkButtonSliding = ({ text, url }) => {

    return (
        <>
            <div className="read-more-btn">
                <Link
                    className="rbt-btn rbt-switch-btn btn-gradient btn-sm"
                    href={url}
                    target="_blank"
                >
                    <span data-text={text}>{text}</span>
                </Link>
            </div>
            {/* <div className="buy-now-btn">
                <Link
                    className="rbt-btn btn-gradient icon-hover w-50 text-center"
                    href={url}
                    target="_blank"
                >
                    <span className="btn-text">{text}</span>
                    <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                    </span>
                </Link>
            </div> */}

        </>
    );
};

export default LinkButtonSliding;